module.exports = __webpack_public_path__ + "media/emails/daily-mail-c810ae17.png";